/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Stack, Typography } from "@mui/material";
import Accordion from "@/src/components/Accordion/Accordion";
import AccordionGroupProvider from "@/src/components/Accordion/AccordionGroupProvider";
import MuiListNativeStyled from "@/src/components/List/MuiListNativeStyled";
import correspondenceHelpStyle from "./correspondenceHelpStyle";

export const CorrespondenceHelp = () => (
  <>
    <Typography>
      Bitte laden Sie den für Ihren Fall relevanten E-Mail- oder Chatverlauf <strong>vollständig</strong> und <strong>gut lesbar</strong> hoch. Absender
      beziehungsweise Kontakt, Datum und Reihenfolge sollten erkennbar sein. Anhänge laden Sie bitte zusätzlich als eigene Dateien hoch.
    </Typography>
    <Typography variant={"h7"} sx={correspondenceHelpStyle.headline}>
      So bereiten Sie Ihre Unterlagen vor
    </Typography>
    <AccordionGroupProvider>
      <Stack spacing={2} sx={correspondenceHelpStyle.accordionStack}>
        <Accordion title={"E-Mails am Computer speichern"} summaryTypographyVariant={"body1"}>
          <MuiListNativeStyled
            ordered={true}
            sx={correspondenceHelpStyle.list}
            listItems={[
              "Öffnen Sie die relevante E-Mail oder den vollständigen E-Mail-Verlauf.",
              "Wählen Sie „Drucken“ oder „Alle drucken“ und speichern Sie die Datei als PDF.",
              "Prüfen Sie, ob Absender, Empfänger, Datum und Inhalt sichtbar sind.",
            ]}
          />
        </Accordion>
        <Accordion title={"E-Mails auf Smartphone oder Tablet speichern"} summaryTypographyVariant={"body1"}>
          <MuiListNativeStyled
            ordered={true}
            sx={correspondenceHelpStyle.list}
            listItems={[
              "Öffnen Sie die relevante Nachricht oder den E-Mail-Verlauf. Wählen Sie – sofern vorhanden – „Drucken“ oder „Alle drucken“.",
              "Speichern oder teilen Sie die Datei als PDF, wenn Ihr Gerät dies anbietet.",
            ]}
          />
          <Typography sx={correspondenceHelpStyle.note}>
            Andernfalls genügen gut lesbare Screenshots mit Absender, Datum und Reihenfolge, siehe „Screenshots richtig erstellen“.
          </Typography>
        </Accordion>
        <Accordion title={"WhatsApp und andere Chatverläufe speichern"} summaryTypographyVariant={"body1"}>
          <MuiListNativeStyled
            ordered={true}
            sx={correspondenceHelpStyle.list}
            listItems={[
              <>
                Bei <strong>kurzen Verläufen</strong> genügen aufeinanderfolgende Screenshots, auf denen Kontakt oder Gruppenname, Datum und Reihenfolge
                erkennbar sind (siehe „Screenshots richtig erstellen“).
              </>,
              <>
                <strong>Bei längeren Verläufen</strong> nutzen Sie – sofern in der verwendeten App verfügbar – „Chat exportieren“ und öffnen die exportierte
                Textdatei, um sie nach Möglichkeit als PDF zu speichern. Relevante Bilder, Sprachnachrichten und Dokumente laden Sie bitte zusätzlich als eigene
                Dateien hoch.
              </>,
            ]}
          />
        </Accordion>
        <Accordion title={"Screenshots richtig erstellen"} summaryTypographyVariant={"body1"}>
          <MuiListNativeStyled
            ordered={true}
            sx={correspondenceHelpStyle.list}
            listItems={[
              <>
                <strong>Windows</strong>: Windows + Umschalt + S.
              </>,
              <>
                <strong>Mac</strong>: Umschalt + ⌘ + 4.
              </>,
              <>
                <strong>iPhone/iPad:</strong> Bei Geräten ohne Home-Taste drücken Sie gleichzeitig die Seiten- beziehungsweise obere Taste und die Lauter-Taste.
              </>,
              <>
                <strong>Android</strong>: Ein-/Aus- und Leiser-Taste gleichzeitig; die Tastenkombination kann je nach Gerät abweichen.
              </>,
            ]}
          />
          <Typography sx={correspondenceHelpStyle.note}>
            Bei längeren Verläufen erstellen Sie mehrere aufeinanderfolgende Screenshots. Kontakt, Datum, Reihenfolge und Zusammenhang müssen erkennbar bleiben.
          </Typography>
        </Accordion>
      </Stack>
    </AccordionGroupProvider>
  </>
);
